import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "w-panel",
  "aria-label": "Заполнение графика"
}
const _hoisted_2 = { class: "w-panel-head" }
const _hoisted_3 = { class: "w-builder-fields" }
const _hoisted_4 = { class: "w-field" }
const _hoisted_5 = { class: "w-field" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "w-field w-builder-repeat" }
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 0,
  class: "w-field"
}
const _hoisted_10 = { class: "w-field" }
const _hoisted_11 = { class: "w-field" }
const _hoisted_12 = { class: "w-field" }
const _hoisted_13 = { class: "w-field" }
const _hoisted_14 = ["value"]
const _hoisted_15 = { class: "w-builder-breaks" }
const _hoisted_16 = { class: "w-breaks-head" }
const _hoisted_17 = { class: "w-break-list" }
const _hoisted_18 = { class: "w-field" }
const _hoisted_19 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_20 = { class: "w-field" }
const _hoisted_21 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_22 = { class: "w-field" }
const _hoisted_23 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_24 = { class: "w-field" }
const _hoisted_25 = ["onUpdate:modelValue", "aria-label"]
const _hoisted_26 = ["aria-label", "onClick"]
const _hoisted_27 = ["role"]
const _hoisted_28 = { class: "w-plan-bottom" }
const _hoisted_29 = { class: "w-plan-summary" }
const _hoisted_30 = { class: "w-actions" }

import { computed, watch } from 'vue';
import { useScheduleStore } from '@/store/calendar/scheduleModule';
import { MAX_PATTERN_DAYS } from '~utils/calendarModel';
import type { PlanPattern } from '@/store/calendar/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'ScheduleBuilder',
  setup(__props) {

const PATTERNS: { value: PlanPattern; label: string }[] = [
  { value: 'once', label: 'Выбранный день' },
  { value: 'weekday', label: 'По будням' },
  { value: 'every', label: 'Каждый день' },
  { value: '2on2', label: '2 рабочих / 2 выходных' },
];

const store = useScheduleStore();
const plan = computed(() => store.plan);

const summary = computed(() => {
  const days = store.patternSpec.dates.length;
  if (!days) return `Укажите корректный период до ${MAX_PATTERN_DAYS} дней.`;
  return `${days} дн. · приём ${plan.value.duration} мин. · `
    + `регламентированных перерывов в день: ${plan.value.breaks.length}`;
});

// Результат проверки относится к конкретному плану — после правки он устаревает
watch(plan, () => {
  store.planPreview = null;
}, { deep: true });

return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[12] || (_cache[12] = _createElementVNode("h2", null, "Заполнить график", -1)),
      _createElementVNode("button", {
        class: "w-button w-icon w-ghost",
        type: "button",
        "aria-label": "Закрыть заполнение графика",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(store).builderOpen = false))
      }, [
        _createVNode(_component_q_icon, { name: "close" })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("label", _hoisted_4, [
        _cache[13] || (_cache[13] = _createTextVNode(" С даты ", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((plan.value.from) = $event)),
          type: "date"
        }, null, 512), [
          [
            _vModelText,
            plan.value.from,
            void 0,
            { lazy: true }
          ]
        ])
      ]),
      _createElementVNode("label", _hoisted_5, [
        _cache[14] || (_cache[14] = _createTextVNode(" По дату ", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((plan.value.to) = $event)),
          type: "date",
          disabled: plan.value.pattern === 'once'
        }, null, 8, _hoisted_6), [
          [
            _vModelText,
            plan.value.to,
            void 0,
            { lazy: true }
          ]
        ])
      ]),
      _createElementVNode("label", _hoisted_7, [
        _cache[15] || (_cache[15] = _createTextVNode(" Повторение ", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((plan.value.pattern) = $event))
        }, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(PATTERNS, (option) => {
            return _createElementVNode("option", {
              key: option.value,
              value: option.value
            }, _toDisplayString(option.label), 9, _hoisted_8)
          }), 64))
        ], 512), [
          [_vModelSelect, plan.value.pattern]
        ])
      ]),
      (plan.value.pattern === '2on2')
        ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
            _cache[16] || (_cache[16] = _createTextVNode(" Начало цикла ", -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((plan.value.anchor) = $event)),
              type: "date"
            }, null, 512), [
              [
                _vModelText,
                plan.value.anchor,
                void 0,
                { lazy: true }
              ]
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("label", _hoisted_10, [
        _cache[17] || (_cache[17] = _createTextVNode(" Начало приёма ", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((plan.value.start) = $event)),
          type: "time",
          step: "60"
        }, null, 512), [
          [
            _vModelText,
            plan.value.start,
            void 0,
            { lazy: true }
          ]
        ])
      ]),
      _createElementVNode("label", _hoisted_11, [
        _cache[18] || (_cache[18] = _createTextVNode(" Окончание ", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((plan.value.end) = $event)),
          type: "time",
          step: "60"
        }, null, 512), [
          [
            _vModelText,
            plan.value.end,
            void 0,
            { lazy: true }
          ]
        ])
      ]),
      _createElementVNode("label", _hoisted_12, [
        _cache[19] || (_cache[19] = _createTextVNode(" Длительность, мин ", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((plan.value.duration) = $event)),
          type: "number",
          min: "1",
          step: "1"
        }, null, 512), [
          [
            _vModelText,
            plan.value.duration,
            void 0,
            {
              lazy: true,
              number: true
            }
          ]
        ])
      ]),
      _createElementVNode("label", _hoisted_13, [
        _cache[20] || (_cache[20] = _createTextVNode(" Кабинет ", -1)),
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((plan.value.roomId) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).allowedRooms, (room) => {
            return (_openBlock(), _createElementBlock("option", {
              key: room.id,
              value: room.id
            }, _toDisplayString(room.number ?? room.id) + " · " + _toDisplayString(room.purpose || room.name), 9, _hoisted_14))
          }), 128))
        ], 512), [
          [
            _vModelSelect,
            plan.value.roomId,
            void 0,
            { number: true }
          ]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _cache[22] || (_cache[22] = _createElementVNode("h3", null, "Регламентированные перерывы", -1)),
        _createElementVNode("button", {
          class: "w-button w-ghost",
          type: "button",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(store).addPlanBreak()))
        }, [
          _createVNode(_component_q_icon, { name: "add" }),
          _cache[21] || (_cache[21] = _createTextVNode(" Перерыв ", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(plan.value.breaks, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "w-break-row"
          }, [
            _createElementVNode("label", _hoisted_18, [
              _cache[23] || (_cache[23] = _createTextVNode(" Перерыв ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((item.label) = $event),
                type: "text",
                "aria-label": `Название перерыва ${index + 1}`
              }, null, 8, _hoisted_19), [
                [
                  _vModelText,
                  item.label,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_20, [
              _cache[25] || (_cache[25] = _createTextVNode(" Закрывает ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": ($event: any) => ((item.scope) = $event),
                "aria-label": `Область перерыва ${index + 1}`
              }, [...(_cache[24] || (_cache[24] = [
                _createElementVNode("option", { value: "staff" }, "Врача", -1),
                _createElementVNode("option", { value: "room" }, "Кабинет", -1)
              ]))], 8, _hoisted_21), [
                [_vModelSelect, item.scope]
              ])
            ]),
            _createElementVNode("label", _hoisted_22, [
              _cache[26] || (_cache[26] = _createTextVNode(" С ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((item.start) = $event),
                type: "time",
                "aria-label": `Начало перерыва ${index + 1}`
              }, null, 8, _hoisted_23), [
                [
                  _vModelText,
                  item.start,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("label", _hoisted_24, [
              _cache[27] || (_cache[27] = _createTextVNode(" До ", -1)),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": ($event: any) => ((item.end) = $event),
                type: "time",
                "aria-label": `Окончание перерыва ${index + 1}`
              }, null, 8, _hoisted_25), [
                [
                  _vModelText,
                  item.end,
                  void 0,
                  { lazy: true }
                ]
              ])
            ]),
            _createElementVNode("button", {
              class: "w-button",
              type: "button",
              "aria-label": `Убрать перерыв ${index + 1}`,
              onClick: ($event: any) => (_unref(store).removePlanBreak(index))
            }, [
              _createVNode(_component_q_icon, { name: "close" })
            ], 8, _hoisted_26)
          ]))
        }), 128))
      ])
    ]),
    (_unref(store).planPreview)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["w-preview", _unref(store).planPreview.ok ? 'w-notice' : 'w-error']),
          role: _unref(store).planPreview.ok ? 'status' : 'alert'
        }, _toDisplayString(_unref(store).planPreview.text), 11, _hoisted_27))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, _toDisplayString(summary.value), 1),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("button", {
          class: "w-button",
          type: "button",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (_unref(store).previewPlan()))
        }, "Проверить"),
        _createElementVNode("button", {
          class: "w-button primary",
          type: "button",
          onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(store).applyPlan()))
        }, " Сохранить график ")
      ])
    ])
  ]))
}
}

})